<template>
  <div
    class="w-full top-0 bg-root-6 sticky z-30 lg:pl-24 transition-all duration-300 ease"
    :class="{ 'lg:pl-52': !isSideNavCollapse }"
  >
    <div
      class="px-6 md:px-8 pt-10 pb-4 hidden lg:flex justify-between items-center"
    >
      <div class="font-bold capitalize text-fg-default text-2xl">
        <div v-if="routeName === 'dashboard'">
          <h3 class="text-lg md:text-2xl font-normal">
            {{ getTimeofDay }},
            <span class="font-bold">{{ user.firstName }} </span>
          </h3>
        </div>
        <div
          class="capitalize flex items-center gap-9 fade-in-animation"
          v-else
        >
          {{ pageTitle }}
          <div
            v-if="
              routeName === 'transactions' &&
              tenantPermission('terminal-access')
            "
          >
            <div class="hidden md:block">
              <transaction-category-dropdown />
            </div>
          </div>
        </div>
        <div
          v-if="showBack && !isWithdrawalRoute"
          @click="goBack"
          class="lg:mt-2 -top-8 z-10 cursor-pointer flex items-center justify-start w-20"
        >
          <back-arrow />
          <p class="text-13px text-root-4 ml-2 font-normal">Back</p>
        </div>
        <div
          v-if="activeTitle"
          class="font-normal pt-2 md:pt-0 pr-2 pl-3 md:pl-0 text-sm lg:text-base text-gray-40"
        >
          {{ activeTitle }}
        </div>
      </div>
      <div class="hidden lg:flex items-center mr-40">
        <div
          class="beamerTrigger cursor-pointer text-sm py-3 px-4 mr-5 border border-primary hover:opacity-70 rounded"
        >
          What's New
        </div>

        <!-- <div
        @click="toggleTheme"
          :class="isDarkMode ? 'bg-primary text-white' : 'fg-disabled'"
          class="rounded-3xl text-sm flex items-center font-normal cursor-pointer px-5 py-1.5"
        >
          <span class="pr-3 text-fg-default"> {{ isDarkMode ? " Light" : "Dark" }}</span>
          <moon-icon v-if="!isDarkMode" /> <sun-icon v-else />
        </div> -->
        <notification-count-icon />
        <div>
          <el-dropdown trigger="click">
            <el-avatar class="bg-blue-10 border-root-1" :size="40"
              >{{ user.firstName.charAt(0).toUpperCase()
              }}{{ user.lastName.charAt(0).toUpperCase() }}</el-avatar
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div @click="goToProfile" class="flex items-center gap-3 p-2">
                  <profile-icon />
                  Profile
                </div></el-dropdown-item
              >
              <el-dropdown-item>
                <div @click="logout" class="flex items-center gap-2 p-2">
                  <div class="flex items-center"><logout-icon /></div>
                  <span class="text-red-2">Logout</span>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- The translation dropdown which can be seen on the UI is in the index.html file -->
      </div>
    </div>
    <!-- for small screens -->
    <div class="lg:hidden">
      <!-- The translation dropdown which can be seen on the UI is in the index.html file -->
      <div
        class="small-screen-header background flex items-center justify-between px-6 md:px-14 pt-9 pb-3 md:pt-0 md:pb-0 md:py-4 mb-2 pr-36"
      >
        <!-- left-sde -->
        <div class="flex items-center gap-3">
          <div @click="$emit('toggle-drawer')">
            <hamburger-icon />
          </div>

          <app-logo />
        </div>
        <!-- right-side -->
        <div class="flex pr-0 md:pr-24">
          <div
            class="border-root-1 flex justify-center items-center h-7 w-7 md:h-9 md:w-9 mx-2 md:mx-3 rounded-full"
          >
            <notification-count-icon />
          </div>
          <el-avatar class="bg-blue-10" :size="avatarSize">{{
            user.firstName.charAt(0).toUpperCase()
          }}</el-avatar>
        </div>
      </div>
      <div
        v-if="routeName === 'dashboard'"
        class="px-6 md:px-14 mb-8 text-root-2"
      >
        <h3 class="text-lg md:text-xl">
          {{ getTimeofDay }},
          <span class="capitalize">{{ user.firstName }}</span>
        </h3>
        <div class="font-normal pt-2 text-gray-10 text-xs md:text-sm">
          Overview Summary
        </div>
      </div>
    </div>
    <agreement-dialog
      v-if="showAgreementDialog"
      :showDialog="showAgreementDialog"
      :agreementData="agreementContract"
      @closeDialog="closeDialog"
      @agreementConfirmed="showDepositType"
    />
    <deposit-type-dialog
      v-if="showDepositTypeDialog"
      :showDialog="showDepositTypeDialog"
      @closeDialog="closeDepositTypeDialog"
      @hasPendingDeposit="showEditPendingDepositDialog = true"
      @showFiatCurrency="showDepositScreen('depositAmount')"
      @completedDeposit="showPendingDepositDialog = true"
      @showWallet="showWallet"
      :view="view"
      :transaction="currentTransaction"
    />
    <wallet-dialog
      v-if="showWalletDialog"
      @closeDialog="closeWalletDialog"
      @goBack="showDepositType"
      :showDialog="showWalletDialog"
      :walletAddress="walletAddress"
    />
    <deposit-amount-dialog
      v-if="showDepositAmountDialog"
      :showDialog="showDepositAmountDialog"
      @closeDialog="closeDepositAmountDialog"
      @completedDeposit="showPendingDepositDialog = true"
      :toShowTransferType="transferType"
    />
    <pending-deposit-dialog
      v-if="showPendingDepositDialog"
      :showDialog="showPendingDepositDialog"
      @closeDialog="closePendingDepositDialog"
      @completedDeposit="depositCompleted = true"
    />
    <edit-pending-deposit
      v-if="showEditPendingDepositDialog"
      :showDialog="showEditPendingDepositDialog"
      @closeDialog="closeEditPendingDepositDialog"
      @editPendingDeposit="showDepositAmountScreen"
      @showDepositDetails="showDepositScreen"
    />
    <deposit-pending-dialog
      v-if="showDepositPendingDialog"
      :showDialog="showDepositPendingDialog"
      @closeDialog="closePendingDepositDialog"
      @proceedToDeposit="proceedToDeposit"
      @showDepositDetails="showDepositDetails"
      :pendingDepositDetails="pendingDepositDetails"
    />
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import eventBus from '@/global/eventBus'
import { WITHDRAWAL_ACCESS, DEPOSIT_ACCESS } from '@/utils/constants'
import pendingDeposit from '@/mixins/pendingDeposit.js'
import logout from '@/mixins/logout.js'
import tenant from '@/mixins/tenant.js'
import TransactionCategoryDropdown from '../transactions/dropdowns/TransactionCategoryDropdown.vue'
export default {
  mixins: [pendingDeposit, logout, tenant],
  data: () => ({
    breakpoints,
    showDepositPendingDialog: false,
    notifications: [],
    depositAccess: DEPOSIT_ACCESS,
    withdrawalAccess: WITHDRAWAL_ACCESS,
    isLoading: false,
    showAgreementDialog: false,
    detailsInterval: null,
    showDepositAmountDialog: false,
    showPendingDepositDialog: false,
    showEditPendingDepositDialog: false,
    showDepositTypeDialog: false,
    showWalletDialog: false,
    depositCompleted: false,
    transferType: 'depositAmount',
    view: 'depositType'
  }),
  components: {
    NotificationCountIcon: () =>
      import('@/components/v2/base/NotificationCountIcon.vue'),
    BackArrow: () => import('@/assets/icons/BackArrow.vue'),
    LogoutIcon: () => import('@/assets/v2/icons/LogoutIcon.vue'),
    AppLogo: () => import('@/assets/images/AppLogo.vue'),
    HamburgerIcon: () => import('@/assets/icons/HamburgerIcon.vue'),
    // MoonIcon: () => import('@/assets/icons/MoonIcon.vue'),
    // SunIcon: () => import('@/assets/v2/icons/SunIcon.vue'),
    ProfileIcon: () => import('@/assets/v2/icons/ProfileIcon.vue'),
    DepositPendingDialog: () =>
      import('@/components/deposit/DepositPendingDialog.vue'),
    AgreementDialog: () => import('@/components/deposit/AgreementDialog.vue'),
    DepositAmountDialog: () =>
      import('@/components/deposit/DepositAmountDialog.vue'),
    DepositTypeDialog: () =>
      import('@/components/deposit/DepositTypeDialog.vue'),
    WalletDialog: () => import('@/components/deposit/WalletDialog.vue'),
    PendingDepositDialog: () =>
      import('@/components/deposit/PendingDepositDialog.vue'),
    EditPendingDeposit: () =>
      import('@/components/deposit/EditPendingDeposit.vue'),
    TransactionCategoryDropdown
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    toggleTheme () {
      if (this.userTheme.includes('light-theme')) {
        this.setTheme('dark-theme')
      } else {
        this.setTheme('light-theme')
      }
    },
    proceedToWithdraw () {
      if (!this.withdrawalAccess.includes(this.user.kind)) {
        this.$message({
          showClose: true,
          message: 'No withdrawal access',
          type: 'info'
        })
      }
      this.$router.push('withdrawal')
    },
    goToDeposit () {
      if (this.pendingDepositDetails && this.hasPendingDeposit) {
        this.showDepositPendingDialog = true
      } else {
        this.proceedToDeposit()
      }
    },
    closePendingDepositDialog () {
      this.showDepositPendingDialog = false
    },
    showDepositDetails () {
      this.depositDetails()
    },
    proceedToDeposit () {
      if (
        !this.isbusinessAccountActive ||
        !this.depositAccess.includes(this.user.kind)
      ) {
        this.$message({
          showClose: true,
          message: !this.isbusinessAccountActive
            ? 'Business account is currently not active'
            : 'No deposit access',
          type: 'info'
        })
        return
      }
      if (
        (this.latestTransactions && this.latestTransactions.length > 0) ||
        this.isManualKycType
      ) {
        this.showDepositTypeDialog = true
      } else {
        this.isLoading = true
        const vm = this
        this.$store
          .dispatch('transactions/depositAgreement')
          .then(() => {
            this.showAgreementDialog = true
          })
          .catch((error) => {
            this.handleErrorResponseNotification(error)
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog () {
      this.showAgreementDialog = false
    },
    showDepositType () {
      this.showDepositTypeDialog = true
    },
    depositDetails () {
      if (
        this.transactionDetails.depositMethod ===
        this.$transactionType.LOCAL_TRANSFER
      ) {
        this.$store.dispatch(
          'transactions/setDepositTypeView',
          'localAccountInformation'
        )
      } else if (
        this.transactionDetails.depositMethod ===
        this.$transactionType.ASSET_TRANSFER
      ) {
        this.$store.dispatch(
          'transactions/setDepositTypeView',
          'assetAccountInformation'
        )
      } else {
        this.$store.dispatch(
          'transactions/setDepositTypeView',
          'accountInformation'
        )
      }
      if (this.routeName === 'transactions') {
        this.showDepositTypeDialog = true
      }
    },
    closeDepositAmountDialog () {
      this.showDepositAmountDialog = false
    },
    setTheme (theme) {
      this.$store.dispatch('common/setUserTheme', theme)
      document.documentElement.className = `${theme} ${this.tenantName} ${this.tenantVersion}`
    },
    closeWalletDialog () {
      this.showWalletDialog = false
    },
    closeEditPendingDepositDialog () {
      this.showEditPendingDepositDialog = false
    },
    closeDepositTypeDialog () {
      this.showDepositTypeDialog = false
    },
    goToProfile () {
      this.$router.push('/settings/business-overview')
    },
    goToDashboard () {
      this.$router.push('dashboard')
    },
    toggleDrawer () {
      this.$emit('toggleDrawer')
    },
    showWallet (walletAddress) {
      this.walletAddress = walletAddress
      this.showWalletDialog = true
    },
    showDepositScreen (transferType) {
      this.showDepositAmountDialog = true
      this.transferType = transferType
    },
    showDepositAmountScreen (transferType) {
      this.showDepositAmountDialog = true
      this.transferType = transferType
    },
    getMediaPreference () {
      const hasDarkPreference = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches
      if (hasDarkPreference) {
        return 'dark-theme'
      } else {
        return 'light-theme'
      }
    }
  },
  computed: {
    hasUnreadMessages () {
      return this.$store.state.common.unreadMessages
    },
    isOnDevEnvironment () {
      return process.env.NODE_ENV !== 'production'
    },
    showBack () {
      return this.$route.meta.showBack
    },
    pageTitle () {
      return this.$route.meta.pageTitle
    },
    activeTitle () {
      return this.$route.meta.activeTitle
    },
    isWithdrawalRoute () {
      return this.$route.name === 'withdrawal'
    },
    userTheme () {
      return this.$store.state.common.userTheme
    },
    isDarkMode () {
      return this.$store?.state?.common?.userTheme.includes('dark-theme')
    },
    depositWithdrawAccess () {
      return process.env.VUE_APP_DEPOSIT_WITHDRAW_ACCESS === 'true'
    },
    latestTransactions () {
      if (
        !this.$store.state.transactions.transactions ||
        !this.$store.state.transactions.transactions.items
      ) {
        return []
      }
      return this.$store.state.transactions.transactions.items.slice(0, 3)
    },
    user () {
      return this.$store.state.auth.user
    },
    isManualKycType () {
      return this.$store.state.auth.business.kycType === 'manual'
    },
    routeName () {
      return this.$route.name
    },
    isbusinessAccountActive () {
      return this.$store.state.auth.business.accountActive
    },
    agreementContract () {
      return this.$store.state.transactions.depositContract
    },
    currentTransaction () {
      return this.$store.state.transactions.currentTransaction
    },
    transactionDetails () {
      const details = this.$store.state.transactions.transactionDetails
      return details
    },
    getTimeofDay () {
      var newDate = new Date()
      var hours = newDate.getHours()
      var message =
        hours < 12
          ? 'Good Morning'
          : hours < 18
          ? 'Good Afternoon'
          : 'Good Evening'
      return message
    },
    avatarSize () {
      return breakpoints.mdAndUp ? 35 : 27
    },
    isSideNavCollapse () {
      return this.$store.state.common.sideNavCollapse
    }
  },
  mounted () {
    this.setTheme(this.userTheme)
    eventBus.$on('depositAction', () => {
      this.proceedToDeposit()
    })
    eventBus.$on('depositDetailsEvent', () => {
      this.depositDetails()
    })
    eventBus.$on('showDepositTypeEvent', (transaction) => {
      this.currentTransaction = transaction
      this.showDepositTypeDialog = true
    })
  }
}
</script>
<style scoped>
.text-root-2 {
  color: var(--text-2);
}
.background-1 {
  background: var(--background-1);
}
.background {
  background: var(--background);
}
.small-screen-header {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 1px 3px rgba(3, 2, 7, 0.12);
}
.border-b {
  border: 1px solid var(--border-1);
}
* >>> text {
  transform: rotate(0deg);
}
</style>
